module.exports = __webpack_public_path__ + "resource/img/15771677697760.57a76d78.png";